import { render } from "./App.vue?vue&type=template&id=abb5c7ee"
const script = {}

import exportComponent from "C:\\Users\\m.mizutani\\source\\repos\\hdy-rsv\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__